import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';
import { createElementFromHTML } from '../utilities/js/helper';

export default class extends Controller {
    async connect () {
        this.component = await getComponent(this.element);
        const $parentTeaser = this.element.parentElement.parentElement.parentElement;
        const $loadingSpinner = createElementFromHTML(window.OPTIONS.loader);

        if (!$parentTeaser.classList.contains('termin-teaser')) {
            this.component.on('loading.state:started', () => {
                this.element.appendChild($loadingSpinner.cloneNode(true));
            });

            this.component.on('loading.state:finished', () => {
                this.updateCartCount(document);

                const $loader = this.element.querySelector('[data-loader]');
                if ($loader) {
                    $loader.remove();
                }
            });

            this.component.on('render:finished', () => {
                this.updateCartCount(document);
            });
        } else {
            this.component.on('render:finished', () => {
                this.updateCartCount(this.element);

                if ($parentTeaser.classList.contains('termin-teaser')) {
                    $parentTeaser.classList.add('in--cart');
                }
            });
        }
    }

    updateCartCount ($countParent) {
        const $cartItemsCount = $countParent.querySelector('[data-cart-count]');
        const cartCount = $cartItemsCount ? parseInt($cartItemsCount.dataset.cartCount, 10) : 0;
        const $$shopBasketIndicator = document.querySelectorAll('[data-basket]');

        if ($$shopBasketIndicator.length > 0) {
            $$shopBasketIndicator.forEach($shopBasketIndicator => {
                if (cartCount === 0) {
                    $shopBasketIndicator.classList.remove('is--active');
                } else {
                    $shopBasketIndicator.classList.add('is--active');
                }

                $shopBasketIndicator.textContent = cartCount;
            });
        }
    }
}
